import { useRouter } from 'next/router'

import useSWR from 'swr'

import { LocalizedParentArticlesDocument } from '@/generated/contentful'

import { client } from '@/lib/contentful/client'
import { serializeCacheKey } from '@/lib/contentful/utils'

import { Button } from '@/components/Button'

type Props = {
	className?: string
	priority?: (string | undefined)[]
}

export function ArticleParentFeedGrid({ className, priority }: Props) {
	const { locale, isPreview } = useRouter()

	const { data } = useSWR(
		serializeCacheKey('parentArticles', {
			locale
		}),
		() =>
			client({ preview: Boolean(isPreview) }).request(LocalizedParentArticlesDocument, {
				locale,
				where: { editStatus: '🟢 live', parentArticle_exists: false },
				preview: Boolean(isPreview)
			})
	)

	if (!data) return null

	return (
		<div className={className} data-testid="article-parent-feed-grid">
			<div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-28">
				{data.parentArticles?.items.map((articleCollection) => {
					if (!articleCollection) return null

					const { sys, title, slug } = articleCollection

					return (
						<div className="space-y-8" key={sys.id}>
							{title && <h3 className="text-2xl font-medium text-bc-black">{title}</h3>}

							{slug && (
								<Button
									anchorLink={slug}
									showIcon={true}
									variant="subtle"
									size="large"
									className="inline-flex"
								>
									Learn More
								</Button>
							)}
						</div>
					)
				})}
			</div>
		</div>
	)
}
